/**
 * Traps keyboard focus within an element until interaction moves away.
 * Focuses the first focusable child and cycles Tab / Shift+Tab between the
 * first and last focusable elements.
 * @param {Element} element - The element to trap focus within.
 */
export default function trapFocus(element) {
  const focusableEls = element.querySelectorAll(
    'video, iframe, a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
  );
  const firstFocusableEl = focusableEls[0];

  if (!firstFocusableEl) {
    return;
  }

  firstFocusableEl.focus(); // Focusing onto the modal

  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  const KEYCODE_TAB = 9;

  element.addEventListener('keydown', e => {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // Shift + tab
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else if (document.activeElement === lastFocusableEl) {
      // Tab
      firstFocusableEl.focus();
      e.preventDefault();
    }
  });
}
